export default function paginate(total, currentPage = 1, perPage = 15, perSide = 3, prevNext = true) {

    const totalPages = Math.ceil(total / perPage)
    
    const pagesToLeft  = currentPage - 1;
    const pagesToRight = totalPages - currentPage; 

    const pagesToRenderLeft = Math.min(pagesToLeft, perSide)
    const pagesToRenderRight = Math.min(pagesToRight, perSide)

    let pagesToRender = 1                   //current page
        pagesToRender += pagesToRenderLeft  //left links
        pagesToRender += pagesToRenderRight //right links

    let links = Array(pagesToRender)
        .fill(null)
        .map(
            (_, index) => {
                const page = currentPage - pagesToRenderLeft + index

                return {
                    label  : page,
                    page   : page,
                    active : page == currentPage
                }
            }
        )

    if(prevNext && currentPage !== 1){
        links.unshift({
            label: '<',
            page : currentPage - 1
        })
    }

    if(prevNext && currentPage !== totalPages){
        links.push({
            label: '>',
            page : currentPage + 1
        })
    }

    return links
}